import { StrongBoxComplianceType } from "@nkr/enums/index";

export interface IStrongBoxComplianceItem {
    type: StrongBoxComplianceType,
    description: string,
    strongBoxCenterId?: number
    centerId?: number,
    strongBoxOpoId?: number,
    opoId?: number,
    centerAlias: string
}